import { render } from "./ManageFlottaPage.vue?vue&type=template&id=09d49ecb"
import script from "./ManageFlottaPage.vue?vue&type=script&lang=js"
export * from "./ManageFlottaPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__